import '@/css/styles.scss';
import { inViewPort, ViewportObserver } from './ViewportObserver';
import { observeElementSize } from './elementSizeObserver';
import { HoverObserver } from './HoverObserver';
import { saveAsFile } from './saveFile';
import { debounceEvent } from './events';
import { submitForm, focusElement } from './forms';
import { styleReconnectModal } from './reconnectModal';

import './iframes';

declare global {
	interface Window {
		inViewPort: any;
		saveAsFile: any;
		afterRouteChange: any;
		debounceEvent: any;
		submitForm: any;
		focusElement: any;
	}
}


window.addEventListener('load', (e) => {	

	observeElementSize();

	//* Setup up mutaion observer for new elements
	const config = { attributes: false, childList: true, subtree: true };
	const observer = new MutationObserver((mutations, observer) => {		
		ViewportObserver();
		HoverObserver();
		styleReconnectModal();
	});
	observer.observe(document.getElementsByTagName("body")[0], config);

	ViewportObserver();
	HoverObserver();	
	styleReconnectModal();
});

window.inViewPort = inViewPort;
window.saveAsFile = saveAsFile;
window.debounceEvent = debounceEvent;
window.submitForm = submitForm;
window.focusElement = focusElement;
